import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import { View, Text } from 'react-native';
import { Button } from 'root/globals/Elements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import defaults from 'root/globals/Defaults.less';
import document_item from './DocumentItem.less';

const styles = {...defaults, ...document_item};

export default class DocumentItem extends CustomComponent {
    _onClick() {
        if(this.props.document.secured == 't')
            this.props.parent.props.onUnauthenticated();

        this.props.parent.setState({selected_document: this.props.document, show_document_dialog: true});
    }
    
    render() {
        return(
            <TouchableArea className={['d-flex flex-row align-items-center py-md-3 py-2 my-1 px-4 w-100 border', styles['background-color-white']]} onPress={this._onClick}>
                <View className={['d-flex justify-content-center align-items-center rounded', this.props.backgroundColor, styles['tools-icon']]}>
                    <FontAwesomeIcon icon={this.props.icon} className={['fa-fw', this.props.color, styles['f-3']].join(' ')}/>
                </View>
                <Text className={['pl-2', styles['text-light'], styles['color-dark-grey'], styles['f-1-2-5']]}>{this.props.document.title}</Text>
                {(!_.is_empty(this.props.second_icon) && <FontAwesomeIcon icon={this.props.second_icon} className={['fa-fw ml-auto', styles['color-red-pink'], styles['f-1-5']].join(' ')}/>)}
            </TouchableArea>
        );
    }
}